'use strict';

var reactIs = {exports: {}};

exports.__module = reactIs;
//# sourceMappingURL=index10.cjs.map
